import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { SERVER_API_URL } from '../app.constants';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

    constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((err: any) => {
                    // A 401 on an API call normally means we are not authenticated — start a fresh PKCE
                    // login and return the user to where they were. But only do so when we do NOT already
                    // hold a valid (unexpired) access token: if we just obtained a token and the server
                    // still rejects it, re-logging in would produce the same token and loop forever, so
                    // we let the error surface instead. (403 is a genuine authorization denial, not an
                    // authentication failure, so it is left alone here too.)
                    if (err instanceof HttpErrorResponse && err.status === 401
                        && request.url.indexOf(SERVER_API_URL) !== -1
                        && !this.oktaAuth.getAccessToken()) {
                        this.oktaAuth.setOriginalUri(window.location.pathname + window.location.search);
                        void this.oktaAuth.signInWithRedirect();
                    }
                    return throwError(err);
                })
            );
    }
}
